<template>
  <!-- container -->
  <div class="container">
    <div class="col-sm-8 m-sm-auto col-md-5 m-md-auto">
      <h2 class="text-center py-3 py-sm-5">ログイン</h2>
      <form class="form-group" @submit.prevent="submit()">
        <div class="form-group">
          <label for="userID" class="sr-only">ユーザー名（メールアドレス）</label>
          <input type="mail" class="form-control" placeholder="ユーザー名（メールアドレス）" id="userID" v-model='credencials.email'>
        </div>
        <div class="form-group mb-5">
          <label for="pass" class="sr-only">パスワード</label>
          <input type="password" class="form-control" placeholder="パスワード" id="pass" v-model='credencials.password'>
        </div>
        <button class="btn btn-primary btn-block mb-5" type="submit">ログイン</button>
        <p v-if="error" class="error-msg">{{ error }}</p>
      </form>
      <p class="text-right">パスワードをお忘れの方は<router-link to="/password">コチラ</router-link></p>
    </div>
  </div>
</template>

<script>
import api from 'api'
import auth from '../../auth'
import util from 'util/lecturer'
import modal from 'util/modal'
export default {
  data () {
    return {
      credencials: {
        email: '',
        password: ''
      },
      error: '',
      localstorageError: 'Safariをお使いの場合、プライベートブラウズになっている可能性があります。通常モードに切り替えてお試しください。'
    }
  },
  mounted () {
    try {
      util.isInvalidLocalStrage()
    } catch (e) {
      modal.showMessageModal(this, this.localstorageError)
    }
  },
  methods: {
    submit () {
      if (!this.isCredencialsValid) return

      var cred = {
        email: this.credencials.email,
        password: this.credencials.password
      }
      var redirect = this.$route.query.redirect
      ? this.$route.query.redirect : '/mypage'
      auth.login(this, cred).then(_ => {
        util.isInvalidLocalStrage()
        this.$router.push(redirect)
      }).catch(err => {
        if (err && err.body && err.body.message) {
          this.error = err.body.message
        } else {
          let message = '予期せぬエラーが発生しました。'
          let clientErrorMessage = err.message
          if (err.message === 'The quota has been exceeded.') {
            // Localstorageのエラーの場合はメッセージを修正する
            message = this.localstorageError
            clientErrorMessage = 'Localstorageが使用できません。'
          }
          this.error = message
          this.sendAlert(this.credencials.email, clientErrorMessage)
        }
      })
    },
    sendAlert (email, message) {
      let error = {
        'type': 'ClientError',
        'email': email,
        'message': message
      }
      api.sendClientError(this, error)
    }
  },

  computed: {
    isCredencialsValid () {
      if (!this.credencials.email || !this.credencials.password) {
        this.error = 'メールアドレスまたはパスワードを入力してください'
        return false
      }
      if (!util.validateEmail(this.credencials.email)) {
        this.error = 'メールアドレスまたはパスワードが間違っています'
        return false
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?49313f6e